import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Facet, FacetValue, OccEndpointsService, ProductSearchPage} from '@spartacus/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {map} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

export const RELEVANCE: string = ':relevance';
export const FACET_PUBLISHER: string = ':publisher:';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class FacetSearchService {
  /** currently opened facet */
  private activeFacetName: string;
  private _backendFacets = new ReplaySubject<Facet[]>();

  get backendFacets(): Observable<Facet[]> {
    return this._backendFacets.asObservable();
  }

  constructor(
    protected router: Router,
    private occEndpointsService: OccEndpointsService,
    protected httpClient: HttpClient
  ) {
    this.getFacetProductSearchPage()
      .pipe(
        untilDestroyed(this),
        map((httpResponse) => httpResponse?.body?.facets?.filter((facet) => facet.visible) ?? [])
      )
      .subscribe((facets) => this._backendFacets.next(facets));
  }

  /**
   * Performs search by given facet parameters.
   *
   * @param facet facet used for search
   * @param query search query
   */
  searchByFacet(facet: string, query: string): void {
    this.router.navigate(['/search'], {
      queryParams: {query: facet + query},
      queryParamsHandling: 'merge',
    });
  }

  setActiveFacet(facetName: string): void {
    this.activeFacetName = facetName;
  }

  getActiveFacetName(): string {
    return this.activeFacetName;
  }

  eraseActiveFacet(facetName: string): void {
    if (this.activeFacetName === facetName) {
      this.activeFacetName = '';
    }
  }

  /**
   * Method that check if facetValue form a facet is in a facet list
   *
   */
  isActiveFacetValue(facetValue: FacetValue, facetName: string, facets: Facet[]): boolean {
    const facetFromList: Facet = facets.find((facet) => facet.name === facetName);
    return facetFromList?.values.some((value) => value.name === facetValue.name);
  }

  /**
   * Method that check if facet from a list has any values
   */
  public hasActiveValue(facetName: string, facets: Facet[]): boolean {
    const facetFromList: Facet = facets.find((facet) => facet.name === facetName);
    return !!facetFromList?.values?.length;
  }

  private getFacetProductSearchPage(): Observable<HttpResponse<ProductSearchPage>> {
    const apiUrl: string = this.occEndpointsService.buildUrl('/products/search');
    const header: HttpHeaders = new HttpHeaders();
    return this.httpClient.get<ProductSearchPage>(apiUrl, {
      params: {
        fields: 'facets',
        lang: 'en',
      },
      headers: header,
      observe: 'response',
    });
  }
}
